import { render, staticRenderFns } from "./ApplyLayout.vue?vue&type=template&id=96656708&scoped=true&"
import script from "./ApplyLayout.vue?vue&type=script&lang=js&"
export * from "./ApplyLayout.vue?vue&type=script&lang=js&"
import style0 from "./ApplyLayout.vue?vue&type=style&index=0&id=96656708&lang=less&scoped=true&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "96656708",
  null
  
)

export default component.exports